import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/finance/vendor-payments/$paymentId',
}).lazy(() => import('./vendor-payments.$paymentId.index.lazy').then((d) => d.Route))
